import { EventTypes } from "modules/orders-manage/models/order-events";
import { CommonBusinessEventProps } from "./common";

export const OrderSignedBusinessEvent = (props: CommonBusinessEventProps) => null;

OrderSignedBusinessEvent.TYPE = EventTypes.OrderSignedBusinessEvent;
